import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateSubstractCounters() {
    return (
        <div data-cy="historic-icon-updateSubstractCounters">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateSubstractCounters" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faTasks} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
